import { Box, Stack, StackProps } from '@mui/material';
import { MonthSwitch } from './month-switch';
import { WeekDayCell } from './week-day-cell';
import { useCalendarGrid } from '../../hooks/use-calendar-grid';
import { DayCell } from './day-cell';

const weekDays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sat', 'Su'];

type Props = StackProps;

export const Calendar = ({ sx, ...props }: Props) => {
  const days = useCalendarGrid();

  return (
    <Stack {...props} sx={{ userSelect: 'none', ...sx }}>
      <MonthSwitch />

      <Box
        sx={{ mt: '12px', display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', rowGap: '4px' }}
      >
        {weekDays.map((dayLabel) => (
          <WeekDayCell key={dayLabel}>{dayLabel}</WeekDayCell>
        ))}

        {days.map((day) => (
          <DayCell key={day.date.unix()} calendarDay={day} />
        ))}
      </Box>
    </Stack>
  );
};
